import Axios from "../config/config";

class ScormAPI {

    constructor( courseId, launchFile, scormVersion = "1.2", onUpdate, resumeData = null ) {
        this.courseId = courseId;
        this.launchFile = launchFile;
        this.scormVersion = scormVersion;
        this.initialized = false;
        this.data = {};
        this.lastError = "0";
        this.progress = 0;
        this.totalSlides = 0;
        this.currentSlide = 0;
        this.score = 0;
        this.lessonStatus = "incomplete";
        this.playerTrackingStarted = false;
        this.onUpdate = onUpdate
        // 🔥 FIX HERE (IMPORTANT)
        if (typeof resumeData === "string") {
            this.data["cmi.suspend_data"] = resumeData;
        }
    }

    // ==================================================
    // LMS INITIALIZE
    // ==================================================

    LMSInitialize(param = "") {
        console.log(
            "LMSInitialize",
            param
        );
        this.initialized = true;
        return "true";
    }

    // ==================================================
    // LMS FINISH
    // ==================================================

    LMSFinish(param = "") {

        console.log(
            "LMSFinish",
            param
        );

        this.saveTracking();

        this.initialized = false;

        return "true";
    }

    // ==================================================
    // LMS GET VALUE
    // ==================================================

    LMSGetValue(key) {

        console.log(
            "LMSGetValue",
            key
        );

        return this.data[key] || "";
    }

    // ==================================================
    // LMS SET VALUE
    // ==================================================

    LMSSetValue(key, value) {

        console.log(
            "SCORM VALUE RECEIVED",
            key,
            value
        );

        this.data[key] = value;

        // ==============================================
        // SCORE
        // ==============================================

        if (
            key === "cmi.core.score.raw" ||
            key === "cmi.score.raw"
        ) {

            const score =
                parseFloat(value);

            if (!isNaN(score)) {

                this.score = score;

                this.progress =
                    Math.max(
                        this.progress,
                        Math.round(score)
                    );
            }
        }

        // ==============================================
        // SCORM 2004 PROGRESS
        // ==============================================

        if (key === "cmi.progress_measure") {

            const percent =
                parseFloat(value) * 100;

            if (!isNaN(percent)) {

                this.progress =
                    Math.round(percent);
            }
        }

        // ==============================================
        // LESSON STATUS
        // ==============================================

        if (
            key === "cmi.core.lesson_status" ||
            key === "cmi.completion_status"
        ) {

            this.lessonStatus = value;

            if (
                value === "completed" ||
                value === "passed"
            ) {

                this.progress = 100;
            }
        }

        // ==============================================
        // SUSPEND DATA FALLBACK
        // ==============================================

        if (key === "cmi.suspend_data") {

            const suspendLength =
                value?.length || 0;

            let calculatedProgress =
                Math.round(
                    (suspendLength / 500) * 100
                );

            calculatedProgress =
                Math.min(
                    95,
                    calculatedProgress
                );

            if (
                calculatedProgress >
                this.progress
            ) {

                this.progress =
                    calculatedProgress;
            }
        }

        // ==============================================
        // LIMIT
        // ==============================================

        this.progress =
            Math.min(
                100,
                this.progress
            );

        console.log(
            "CURRENT PROGRESS %",
            this.progress
        );

        return "true";
    }

    // ==================================================
    // LMS COMMIT
    // ==================================================

    LMSCommit(param = "") {

        console.log(
            "LMSCommit",
            param
        );

        this.saveTracking();

        return "true";
    }

    // ==================================================
    // LMS ERRORS
    // ==================================================

    LMSGetLastError() {

        return this.lastError;
    }

    LMSGetErrorString(errorCode = "") {

        return "No error";
    }

    LMSGetDiagnostic(errorCode = "") {

        return "No diagnostic";
    }

    // ==================================================
    // STORYLINE TRACKING
    // ==================================================

    startStorylineTracking(iframeWindow) {

        if (this.playerTrackingStarted) {

            return;
        }

        this.playerTrackingStarted = true;

        console.log(
            "STARTING STORYLINE TRACKING"
        );

        const interval = setInterval(() => {

            try {

                if (
                    !iframeWindow ||
                    !iframeWindow.GetPlayer
                ) {

                    return;
                }

                const player =
                    iframeWindow.GetPlayer();

                if (!player) {

                    return;
                }

                // ======================================
                // TRY MULTIPLE VARIABLE NAMES
                // ======================================

                const currentSlide =
                    player.GetVar(
                        "CurrentSlide"
                    ) ||
                    player.GetVar(
                        "SlideNumber"
                    ) ||
                    player.GetVar(
                        "MenuSlide"
                    ) ||
                    0;

                const totalSlides =
                    player.GetVar(
                        "TotalSlides"
                    ) ||
                    player.GetVar(
                        "Total_Slides"
                    ) ||
                    0;

                const percent =
                    player.GetVar(
                        "ProgressPercent"
                    ) ||
                    0;

                const score =
                    player.GetVar(
                        "ScorePercent"
                    ) ||
                    0;

                // ======================================
                // SAVE VALUES
                // ======================================

                if (totalSlides > 0) {

                    this.totalSlides =
                        totalSlides;

                    this.currentSlide =
                        currentSlide;

                    const calculated =
                        Math.round(
                            (
                                currentSlide /
                                totalSlides
                            ) * 100
                        );

                    this.progress =
                        Math.max(
                            this.progress,
                            calculated
                        );
                }

                if (percent > 0) {

                    this.progress =
                        Math.max(
                            this.progress,
                            percent
                        );
                }

                if (score > 0) {

                    this.score = score;
                }

                // ======================================
                // COMPLETION
                // ======================================

                if (
                    this.progress >= 100
                ) {

                    this.lessonStatus =
                        "completed";
                }

                console.log({
                    progress:
                        this.progress,
                    currentSlide:
                        this.currentSlide,
                    totalSlides:
                        this.totalSlides,
                    score:
                        this.score
                });

            } catch (e) {

                console.log(
                    "Storyline tracking error",
                    e
                );
            }

        }, 3000);

        this.storylineInterval =
            interval;
    }

    // ==================================================
    // SAVE TRACKING
    // ==================================================

    async saveTracking() {

        try {

            const payload = {
                course_id:atob(this.courseId),
                launch_file:this.launchFile,
                scorm_version:this.scormVersion,
                progress_percentage: this.progress,
                current_slide: this.currentSlide,
                total_slides: this.totalSlides,
                score:  this.score,
                lesson_status: this.lessonStatus,
                suspend_data:this.data["cmi.suspend_data"] || "",
                session_time:this.data["cmi.core.session_time"] || this.data[ "cmi.session_time"] || "",
                scorm_data: this.data
            };
            console.log("TRACKING PAYLOAD", payload);
            const response =
                await Axios.post( "save-scorm-progress/", payload,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${localStorage.getItem("token")}`,
                            "Content-Type":
                                "application/json"
                        },
                        withCredentials:
                            true
                    }
                );

            if (this.onUpdate) {
                this.onUpdate(response.data.data);
            }

        } catch (e) {

            console.error(
                "SCORM TRACKING ERROR",
                e
            );
        }
    }
}

export default ScormAPI;